import React from 'react'

type PillProps = {
  children: React.ReactNode
  className?: string
}

export const Pill: React.FC<PillProps> = ({ children, className = '' }) => {
  const base = 'inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-[#ecf8fd] border border-[#c2e7f9] text-[#0078ae]'
  return <span className={`${base} ${className}`.trim()}>{children}</span>
}

export default Pill

